import { useEffect, useState } from 'react';
import { type ClassValue, clsx } from 'clsx';
import { endOfDay, format, startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { twMerge } from 'tailwind-merge';

export const DATE_TIME_BACKEND_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";

export const DATE_TIME_BACKEND_FORMAT_NO_ZONE = "yyyy-MM-dd'T'HH:mm:ss";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const useDebouncedValue = <T>(inputValue: T, delay: number = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);

  return debouncedValue;
};

export const getBackendTimestamp = (
  date: Date | string,
  formatTypeString: string = DATE_TIME_BACKEND_FORMAT
) => format(toZonedTime(date, 'utc'), formatTypeString);

export const getDayDateRange = (date: Date) => {
  const start = startOfDay(date);
  const end = endOfDay(date);

  return [start, end];
};
